/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import Swal from "sweetalert2";

export default function FooterSection({ storeName, policies }) {
  const safeStoreName = storeName || "LumiBeauty";

  return (
    <footer
      className="border-t"
      style={{
        backgroundColor: "rgba(0,0,0,0.6)",
        borderColor: "rgba(255,255,255,0.1)"
      }}
    >
      <div className="max-w-6xl mx-auto px-4 py-6 text-xs md:text-sm text-white/60 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">

        {/* الحقوق */}
        <p>
          © {new Date().getFullYear()} {safeStoreName}. جميع الحقوق محفوظة.
        </p>

        {/* السياسات */}
        <div className="flex gap-4 flex-wrap">
          {policies?.privacy && (
            <button
              className="hover:text-white transition"
              onClick={() =>
                Swal.fire({
                  title: "سياسة الخصوصية",
                  text: policies.privacy,
                  confirmButtonText: "إغلاق"
                })
              }
            >
              سياسة الخصوصية
            </button>
          )}

          {policies?.delivery && (
            <button
              className="hover:text-white transition"
              onClick={() =>
                Swal.fire({
                  title: "سياسة التوصيل",
                  text: policies.delivery,
                  confirmButtonText: "إغلاق"
                })
              }
            >
              سياسة التوصيل
            </button>
          )}

          {policies?.refund && (
            <button
              className="hover:text-white transition"
              onClick={() =>
                Swal.fire({
                  title: "سياسة الاسترجاع",
                  text: policies.refund,
                  confirmButtonText: "إغلاق"
                })
              }
            >
              سياسة الاسترجاع
            </button>
          )}
        </div>
      </div>
    </footer>
  );
}
